import WorkTypeRow from "./WorkTypeRow";
import {useContext, useEffect} from "react";
import resize from "../../../util/resize";
import workTypeContext from "../../../contexts/workTypes/workTypeContext";
import Spinner from "../../Spinner";

function WorkTypes() {
	const {workTypes, loading} = useContext(workTypeContext);

	useEffect(() => {
		const items = [];

		try {
			resize(items);
		}
		catch (e) {
			console.error(e);
		}

		return () => {
			for (let item of items) {
				item.element.removeEventListener("mousedown", item.handler);
			}
		}
	}, []);

	return (
		<div className={"table-responsive overflow-auto"}>
			<table className={"table table-striped table-bordered mt-2"} id={"resizeMe"}>
				<thead className={"table-light"}>
				<tr>
					<th>Name</th>
					<th>Description</th>
					<th>Unit value</th>
					<th>Unit value (min)</th>
					<th>Unit value (max)</th>
					<th>Unit name</th>
					<th>Group A</th>
					<th>Group B</th>
					<th>Group C</th>
					<th>Actions</th>
				</tr>
				</thead>
				<tbody>
				{loading && <tr><td colSpan={11}><Spinner /></td></tr>}
					{workTypes.map(value => {
						return <WorkTypeRow workType={value} key={value.id}/>;
					})
				}
				</tbody>
			</table>
		</div>
	)
}

export default WorkTypes;